import type { AuthChangeListener, IAuthProvider, LoginCredentials } from "../types/authTypes";

let provider: Promise<IAuthProvider> | undefined;

function getProvider(): Promise<IAuthProvider> {
  provider ??= import("./webAuthProvider").then(module => module.webAuthProvider).catch((error: unknown) => {
    provider = undefined;
    throw error;
  });
  return provider;
}

export const authService = {
  async getSession() {
    return (await getProvider()).getSession();
  },
  async getAccessToken() {
    return (await getProvider()).getAccessToken();
  },
  async login(credentials: LoginCredentials) {
    return (await getProvider()).login(credentials);
  },
  async logout() {
    return (await getProvider()).logout();
  },
  async onAuthStateChange(callback: AuthChangeListener) {
    return (await getProvider()).onAuthStateChange(callback);
  },
};

export type AuthServiceType = typeof authService;
